// extracted by mini-css-extract-plugin
var _1 = "RightPanel-module__animateUploadProgressBarWidth--UY_RC";
var _2 = "RightPanel-module__animatedBackground--lNnI1";
var _3 = "RightPanel-module__closeButton--Na4gT";
var _4 = "RightPanel-module__isOpen--LvmyA";
var _5 = "150";
var _6 = "RightPanel-module__rightPanelFooter--KeEET";
var _7 = "RightPanel-module__rightPanelHeader--VgRjA";
var _8 = "RightPanel-module__rightPanelInner--cIP0Y";
var _9 = "RightPanel-module__rightPanelInnerContainer--bzUH4";
var _a = "RightPanel-module__rightPanelInnerContent--WifhE";
var _b = "320px";
var _c = "RightPanel-module__rightPanelRoot--J5FUx";
var _d = "RightPanel-module__rightPanelRootContainer--CGj4q";
var _e = "RightPanel-module__rightPanelRootContent--CbgsB";
var _f = "336px";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "closeButton", _4 as "isOpen", _5 as "layoutAnimationDurationMs", _6 as "rightPanelFooter", _7 as "rightPanelHeader", _8 as "rightPanelInner", _9 as "rightPanelInnerContainer", _a as "rightPanelInnerContent", _b as "rightPanelMobileWidth", _c as "rightPanelRoot", _d as "rightPanelRootContainer", _e as "rightPanelRootContent", _f as "rightPanelWidth" }
